// extracted by mini-css-extract-plugin
module.exports = {"seeLiveProject2":"Clock-module--seeLiveProject2--2CM6i","sourceCodeProject2":"Clock-module--sourceCodeProject2--6l5hG"};